import { createAsyncThunk } from "@reduxjs/toolkit";
import { handleErrors, type ApiError } from "../../../api/errorUtils";
import type { MyInfoInterface, SingpassOnboardVerificationRequest, SingpassSitterOnboardResponse } from "../ts";
import { sitterAPI } from "../api";

export const GetSingpassAuthUrlThunk = createAsyncThunk<MyInfoInterface>(
  "sitterSlice/singpass_thunk",
  async (_, thunkAPI) => {
    try {
      const { data } = await sitterAPI.getMyinfoUrl();
      return data;
    } catch (err: unknown) {
      return handleErrors(err as ApiError, thunkAPI);
    }
  }
);

export const GetOnboardSingpassThunk = createAsyncThunk<
  SingpassSitterOnboardResponse,
  { code: string; state: string }
>("sitterSlice/onboard_thunk", async (requestData, thunkAPI) => {
  try {
    const { data } = await sitterAPI.onboardSingpass(requestData);
    return data;
  } catch (e: unknown) {
    return handleErrors(e as ApiError, thunkAPI);
  }
});

export const OnboardVerificationThunk = createAsyncThunk<
  void,
  SingpassOnboardVerificationRequest
>("sitterSlice/onboard_verification_thunk", async (requestData, thunkAPI) => {
  try {
    const { data } = await sitterAPI.onboardVerification(requestData);
    return data;
  } catch (e: unknown) {
    return handleErrors(e as ApiError, thunkAPI);
  }
});

const sitterThunk = {
  GetSingpassAuthUrlThunk,
  GetOnboardSingpassThunk,
  OnboardVerificationThunk
};
export default sitterThunk;
